import { ViewPhotoState } from '@/enums/viewEnums.ts';
import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { useWebSocketStore } from '@/store/useWebSocketStore.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';
import { removePendingVideo } from '@/utils/pendingVideoCache.ts';

export const handleVideoRejected = (ctxData: WebSocketMessage) => {
  const { setLastEvents } = useWebSocketStore.getState();
  const { updateVideo } = useProfileStore.getState();

  if (ctxData.video_rejected_event?.video_hid) {
    updateVideo(ctxData.video_rejected_event.video_hid, ViewPhotoState.REJECT);
    setLastEvents({
      videoStateChange: { video_hid: ctxData.video_rejected_event.video_hid }
    });
    void removePendingVideo();
  }
};
